import React from "react";
import { ViewColumn } from "@mui/icons-material";
import { IconButtonProps, IconButton, Tooltip } from "@mui/material";
import ToolButtonsContainer from "@common/components/ToolButtonsContainer";
import { useTranslation } from "react-i18next";

const Button = (props: IconButtonProps) => {
  const { t } = useTranslation();
  return (
    <ToolButtonsContainer>
      <Tooltip title={t("Columns") as string} arrow>
        <span>
          <IconButton
            {...props}
            size="small"
            sx={(theme) => ({
              color: theme.palette.common.white,
            })}
          >
            <ViewColumn />
          </IconButton>
        </span>
      </Tooltip>
    </ToolButtonsContainer>
  );
};

export default Button;
